export const isValidNumber = (value) => typeof value === "number" && !isNaN(value) && isFinite(value);
export const formatDecimalPlaces = (value, minimumFractionDigits = 2) => {
    const actualValue = isValidNumber(value) ? value : 0;
    return actualValue.toLocaleString("en-AU", {
        maximumFractionDigits: minimumFractionDigits,
        minimumFractionDigits: minimumFractionDigits,
        style: "decimal",
        useGrouping: true
    });
};
export const formatDecimalPlacesNumerical = (value, decimalPlaces = 2) => {
    return parseFloat(value.toFixed(decimalPlaces));
};
